import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { Provider } from 'react-redux'
import { store, persistor } from './app/store'
import { PersistGate } from 'redux-persist/integration/react';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import LoginScreen from './screens/LoginScreen'
import ForgotPassword from './screens/ForgotPassword'
import ResetPassword from './screens/ResetPassword'
import ProtectedAdminRoute from './routing/ProtectedAdminRoute'
import AdminHome from './screens/admin/AdminHome'
import ProtectedRoute from './routing/ProtectedUserRoute'
import UserDataCollect from './screens/user/dataCollect/UserDataCollect'
import ClientView from './screens/user/ClientView'
import Event from './screens/user/BH/Event'
import HomePage from './screens/user/HomePage'
import FormPage from './screens/user/FormPage'
import ExcelExport from './screens/user/excelExport/ExcelExport'
import AdminUsers from './screens/admin/users/AdminUsers'
import AdminUsersCreate from './screens/admin/users/AdminUsersCreate'
import AdminProjects from './screens/admin/projects/AdminProjects'
import AdminProjectsCreate from './screens/admin/projects/AdminProjectsCreate'
import AdminOfferTypes from './screens/admin/offer-types/AdminOfferTypes'
import AdminExport from './screens/admin/export/AdminExport'

//change for testing
import AnonymousDataCollection from './screens/user/dataCollect/AnonymousDataCollection'
import ClientExport from './screens/user/clientExport/ClientExport'

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "login",
        element: <LoginScreen />
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />
      },
      {
        path: "reset-password/:resetToken",
        element: <ResetPassword />
      },
      {
        element: <ProtectedAdminRoute />,
        children: [
          {
            path: "admin",
            element: <AdminHome />
          },
          {
            path: "admin/users",
            element: <AdminUsers />
          },
          {
            path: "admin/users/create",
            element: <AdminUsersCreate />
          },
          {
            path: "admin/projects",
            element: <AdminProjects />
          },
          {
            path: "admin/projects/create",
            element: <AdminProjectsCreate />
          },
          {
            path: "admin/offer-types",
            element: <AdminOfferTypes />
          },
          {
            path: "admin/export",
            element: <AdminExport />
          }
        ]
      },
      {
        element: <ProtectedRoute />,
        children: [
          {
            path: "user",
            element: <HomePage />
          },
          {
            path: "user/dataCollection",
            element: <UserDataCollect />
          },
          {
            path: "user/anonymousCollection",
            element: <AnonymousDataCollection />
          },
          {
            path: "user/clientView",
            element: <ClientView />
          },
          {
            path: "user/project",
            element: <FormPage />
          },
          {
            path: "user/excel-export",
            element: <ClientExport />
          },
          {
            path: "user/event",
            element: <Event />
          },
          {
            path: "user/report",
            element: <ExcelExport />
          }
        ]
      }
    ]
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router} />
      </PersistGate>
    </Provider>
  </React.StrictMode>
)